import React, { useRef, useState, useContext } from "react";
import Lang from '../lang/translations';
import helpers from '../_helpers/helpersFunction';
import Spinner from '../spinner/spinner';
import Context from '../context/context';

const PhotoUploadPopup = ({ onClose }) => {
  const context = useContext(Context);
  const fileInputRef = useRef();
  const [uploadLoading, setUploadLoading] = useState(false);
  const [errore, setErrore] = useState(null);

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    if (!e.target.files || e.target.files.length === 0) return;
    setUploadLoading(true);
    setErrore(null);
    try {
      const result = await helpers.uploadFotoProfilo(e.target.files, context.flusso?.moderazione_foto);
      if (result.status === 'ok') {
        onClose();
        window.location.reload();
      } else {
        setErrore(result.status);
      }
    } finally {
      setUploadLoading(false);
    }
  };

  return (
    <div className="popup-overlay foto_obbligatoria">
     
      <div className="popup-container">
        <h2 className="popup-title">
          <Lang w={"carica_foto"} page={"popupFoto"}/>
        </h2>

        <div className="avatar-wrapper">
          <div className="avatar-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="150"
              height="150"
              viewBox="0 0 24 24"
              fill="#e0e0e0"
            >
              <circle cx="12" cy="8" r="4" fill="#bdbdbd" />
              <path
                d="M4 20c0-4 4-6 8-6s8 2 8 6v1H4v-1z"
                fill="#bdbdbd"
              />
            </svg>
          </div>
          <button className="upload-button" onClick={handleUploadClick} aria-label="Carica foto">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="upload-icon"
              viewBox="0 0 24 24"
              fill="white"
              width="24"
              height="24"
            >
              <path d="M5 20h14v-2H5v2zm7-18L5.33 9h3.67v4h4V9h3.67L12 2z" />
            </svg>
          </button>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>

        {uploadLoading && (
          <div className="upload-loader">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Caricamento...</span>
            </div>
            <p style={{ marginTop: "10px", color: "#666" }}>Caricamento in corso...</p>
          </div>
        )}

        {errore && (
          <p className="alert alert-danger" style={{marginTop:"10px"}}>
            <Lang w={errore === 'rejected' ? 'foto_non_conforme' : errore === 'invalid_type' ? 'solo_immagini' : 'grandezza_file'} page={"profilo"}/>
          </p>
        )}

        <p className="popup-text">
            <Lang w={"incentivo"} page={"popupFoto"}/>
        </p>

        {/*<button className="later-button" onClick={onClose}>
            <Lang w={"lo_faro_dopo"} page={"popupFoto"}/>
        </button>*/}
      </div>
    </div>
  );
};

export default PhotoUploadPopup;
